import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/variant/:id',
    name: 'Charts',

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/Main.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "about" */ '@/views/Contact.vue'),
  },
  {
    path: "/FAQ",
    name: "FAW",
    component: () => import(/* webpackChunkName: "about" */ '@/views/FAQ.vue'),
  },
  {
    path: '/',
    name: 'Pre',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/Pre.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: () => import(/* webpackChunkName: "about" */ '@/views/NotFound.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  //localStorage.removeItem('user-password');
  if (to.meta.requiresAuth) {
    next()
  } else next()
})
export default router
